export default __webpack_public_path__ + "static/optimize-supply-5b98a65a200eae62fd2da4fb201bd226.webp";